export default __webpack_public_path__ + "static/media/equity.0c77c383.svg";